import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const CategoryTemplate = styled.div`
  .contents-wrap {
    section.box {
      margin-top: 32px;
      position: relative;

      &:last-child {
        padding-bottom: 32px;
        border-bottom: 8px solid #f9f9f9;
      }
    }

    section.box:first-child,
    .area-menu + section.box {
      margin-top: 20px;
    }

    .category-menubar .swiper {
      padding: 0 16px;
    }

    .veVideo {
      .loading-icon {
        display: none !important;
      }

      video {
        pointer-events: none;
      }
    }

    .section-title {
      .text-ellipsis-wrapper {
        display: flex;
      }

      .text-ellipsis {
        max-width: ${mixin.pxToVw('202')};
        ${mixin.ellipsis(1)}
        margin-right: 5px;
      }
    }
  }

  /* 메인 배너 */
  .corner-main-cate-swiper {
    margin-top: 0 !important;
  }

  /* 퀵메뉴 */
  .corner-quick-menu {
    margin-top: 16px !important;
    overflow: hidden;
  }

  /* 베스트 상품 */
  .corner-ranking {
    .category-menubar {
      padding-bottom: 12px;
    }
  }

  /* 1행(퀵 필터)은 고정 제외 → 래퍼는 흘려보내고 .pin-area만 sticky */
  .lp-filter-bar {
    display: contents;

    .pin-area {
      position: sticky;
      top: 50px;
      left: 0;
      z-index: 11;
    }
  }

  .filter-listbar {
    position: sticky;
    top: 50px;
    left: 0;
    z-index: 11;
  }

  .sorting-bar {
    padding: 16px;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .contents-wrap {
      section.box {
        margin-top: ${mixin.pxToVw('32')};

        &:last-child {
          padding-bottom: ${mixin.pxToVw('32')};
          border-bottom: ${mixin.pxToVw('8')} solid #f9f9f9;
        }
      }

      section.box:first-child,
      .area-menu + section.box {
        margin-top: ${mixin.pxToVw('20')};
      }

      .items-scrollBar.type-prd2linelist,
      .category-menubar .swiper {
        padding: ${mixin.pxToVw('0 16')};
      }
    }

    .corner-quick-menu {
      margin-top: ${mixin.pxToVw('16')} !important;
    }

    .corner-ranking {
      .category-menubar {
        padding-bottom: ${mixin.pxToVw('12')};
      }
    }

    .sorting-bar {
      padding: ${mixin.pxToVw('16')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .contents-wrap {
      section.box {
        max-width: var(--pc-width);
        margin: 0 auto;
        margin-top: 80px;

        &:last-child {
          margin-bottom: 0;
          padding-bottom: 80px;
          border: none;
        }

        &.ly-full {
          max-width: none;
          overflow-x: hidden;

          .menu2line-menubar,
          .category-menubar,
          .section-title {
            max-width: var(--pc-width);
            margin: 0 auto;
          }

          .cate-list,
          .brand-prd-skeleton,
          .component-refresh-btn {
            max-width: var(--pc-width);
            margin-left: auto;
            margin-right: auto;
          }
        }
      }

      .items-scrollBar.type-prd2linelist,
      .category-menubar .swiper {
        padding: 0;
      }
    }

    /* 상품리스트 1줄(PC) 의 세트·날개 스타일은 PrdWingSwiper 컴포넌트가 갖는다 */

    .corner-quick-menu {
      margin-top: 32px !important;
      margin-bottom: -28px !important;

      .box {
        ${mixin.flex({ align: 'center', justify: 'center' })}
        column-gap: 6px;
      }
    }

    .corner-ranking {
      .category-menubar {
        padding-bottom: 16px;
      }
    }

    .bottom-product-wrap {
      max-width: var(--pc-width);
      padding-top: 40px;
      margin: 0 auto;
      border-top: 1px solid #eee;

      .wrap-pagination {
        margin-top: 72px;
      }
    }

    .contents-wrap:empty + .bottom-product-wrap,
    .contents-wrap:has(> .area-menu + div:empty) + .bottom-product-wrap,
    .contents-wrap:has(> .area-menu:only-child) + .bottom-product-wrap {
      border-top: 0;
      padding-top: 0;
      margin-top: -12px;
    }

    .area-menu {
      max-width: var(--pc-width);
      margin: 0 auto 40px auto;
    }

    .filter-listbar,
    .lp-filter-bar .pin-area {
      top: 0;
    }

    .sorting-bar {
      padding: 0 0 20px;
    }
  }
`;
